import type {Result, UseCase} from 'framework';
import type {WeightTrackingError} from '../../domain/errors';
import type {WeightEntry, WeightEntryId} from '../../domain/weight-entry';
import type {WeightTrackingRepository} from '../ports/weight-tracking.repository';

export type UpdateWeightEntryInput = {
  readonly weightEntryId: WeightEntryId;
  readonly weightKg: number;
};

export class UpdateWeightEntry implements UseCase<[UpdateWeightEntryInput], WeightEntry> {
  constructor(private readonly repository: WeightTrackingRepository) {}

  execute(input: UpdateWeightEntryInput): Promise<Result<WeightEntry, WeightTrackingError>> {
    return this.repository.updateEntry(input.weightEntryId, input.weightKg);
  }
}
